var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u5F62\u72B6")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F01\\u4E1A\\u670D\\u52A1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7BA1\\u7406\\u5458\\u89C6\\u89D2-\\u5408\\u4F5C\\u8BA4\\u8BC1\\u5BA1\\u6838\\u4E2D",
    transform: "translate(-907.000000, -706.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-21\\u5907\\u4EFD",
    transform: "translate(360.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(300.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13\\u5907\\u4EFD-4",
    transform: "translate(220.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,14.875 C40,14.53125 39.71875,14.25 39.375,14.25 L37.5,14.25 L37.5,11.75 C37.5,9.671875 35.828125,8 33.75,8 C31.671875,8 30,9.671875 30,11.75 L30,14.25 L28.125,14.25 C27.78125,14.25 27.5,14.53125 27.5,14.875 L27.5,22.375 C27.5,22.71875 27.78125,23 28.125,23 L39.375,23 C39.71875,23 40,22.71875 40,22.375 L40,14.875 Z M35,18.625 C35,19.3125 34.4375,19.875 33.75,19.875 C33.0625,19.875 32.5,19.3125 32.5,18.625 C32.5,17.9375 33.0625,17.375 33.75,17.375 C34.4375,17.375 35,17.9375 35,18.625 Z M36.25,11.75 L36.25,14.25 L31.25,14.25 L31.25,11.75 C31.25,10.375 32.375,9.25 33.75,9.25 C35.125,9.25 36.25,10.375 36.25,11.75 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/lock.201cb790.svg";
export { ForwardRef as ReactComponent };